import { JournalDTO, JournalId, SelectOptionType } from 'types';
import { journalFields } from 'consts/journal/journalFields';

export const parseJournalDTOIntoSelectOptionType: (
    journalDTO: JournalDTO,
) => SelectOptionType<JournalId> = (journalDTO) => ({
    value: journalDTO[journalFields.id],
    label: journalDTO[journalFields.name],
});
